import * as React from 'react'

export const ProgressIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="11"
      height="11"
      viewBox="0 0 11 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M11 1V8C11 8.5625 10.5312 9 10 9C9.4375 9 9 8.5625 9 8V3.4375L2.6875 9.71875C2.3125 10.125 1.65625 10.125 1.28125 9.71875C0.875 9.34375 0.875 8.6875 1.28125 8.3125L7.5625 2H3C2.4375 2 2 1.5625 2 1C2 0.46875 2.4375 0 3 0H10C10.5312 0 11 0.46875 11 1Z"
        fill="currentColor"
      />
    </svg>
  )
}
